module.exports = __webpack_public_path__ + "img/Arrow_Grey.a1554d20.svg";